// extracted by mini-css-extract-plugin
export default {"container":"salad_container__7c--M","title":"salad_title__sO+hk"};